import { render, staticRenderFns } from "./MySettingsNew.vue?vue&type=template&id=e1fd023e&scoped=true"
import script from "./MySettingsNew.vue?vue&type=script&lang=js"
export * from "./MySettingsNew.vue?vue&type=script&lang=js"
import style0 from "./MySettingsNew.vue?vue&type=style&index=0&id=e1fd023e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fd023e",
  null
  
)

export default component.exports